module.exports = __webpack_public_path__ + "static/devopsdday2022-e080e33be9680579754344d757e2ea74.png";